class PurchaseOptions extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    const { signal } = this._abortController;

    this._data = JSON.parse(this.querySelector('[data-purchase-options-data]')?.textContent || '{}');
    this._sellingPlanInput = this.querySelector('[data-selling-plan-input]');
    this._frequency = this.querySelector('[data-frequency]');
    this._usps = this.querySelector('[data-usps]');
    this._subscriptionPrice = this.querySelector('[data-subscription-price]');
    this._oneTimePrice = this.querySelector('[data-one-time-price]');
    this._subscriptionLabel = this.querySelector('[data-subscription-label]');
    this._subscriptionInterval = this.querySelector('[data-subscription-interval]');

    this.addEventListener('change', this._onChange.bind(this), { signal });

    document.addEventListener('variant:change', this._onVariantChange.bind(this), { signal });

    this._render();
  }

  disconnectedCallback() {
    this._abortController?.abort();
  }

  get form() {
    return document.forms[this.getAttribute('form')];
  }

  get variantId() {
    return this.form?.id?.value || this.getAttribute('data-initial-variant');
  }

  get isSubscription() {
    return this.querySelector('[data-purchase-option="subscription"]')?.checked || false;
  }

  get selectedPlanId() {
    return this._frequency ? this._frequency.value : this.getAttribute('data-default-plan');
  }

  _onChange(event) {
    if (!event.target.matches('[data-purchase-option], [data-frequency]')) return;
    this._render();
  }

  _onVariantChange(event) {
    if (event.target !== this.form) return;
    this._render();
  }

  _render() {
    const subscription = this.isSubscription;
    const variant = this._data[this.variantId];
    const plan = variant?.plans?.[this.selectedPlanId];

    if (subscription && !plan) {
      this._sellingPlanInput.disabled = true;
    } else if (subscription) {
      this._sellingPlanInput.disabled = false;
      this._sellingPlanInput.value = this.selectedPlanId;
    } else {
      this._sellingPlanInput.disabled = true;
    }

    if (this._frequency) this._frequency.closest('.purchase-options__frequency').hidden = !subscription;
    if (this._usps) this._usps.hidden = !subscription;

    if (variant && this._oneTimePrice) {
      this._oneTimePrice.textContent = variant.price;
    }

    if (plan) {
      if (this._subscriptionPrice) this._subscriptionPrice.textContent = plan.price;

      if (this._subscriptionInterval) {
        this._subscriptionInterval.textContent = plan.interval ? `· ${plan.interval}` : '';
      }

      if (this._subscriptionLabel) {
        const template = this._subscriptionLabel.getAttribute('data-label-template');
        const fallback = this._subscriptionLabel.getAttribute('data-label-fallback');
        this._subscriptionLabel.textContent =
          plan.savings > 0 ? template.replaceAll('[savings]', plan.savings) : fallback;
      }
    }

    this._updateMainPrice(subscription && plan ? plan.price : variant?.price);
  }

  _updateMainPrice(price) {
    if (!price) return;

    const productInfo = this.closest('.product-info');

    const buttonPrice = productInfo?.querySelector('[data-atc-price]');
    if (buttonPrice) buttonPrice.textContent = price;

    const priceBlock = productInfo?.querySelector('[data-block-type="price"] sale-price');
    if (!priceBlock) return;

    const srOnly = priceBlock.querySelector('.sr-only');
    priceBlock.textContent = '';
    if (srOnly) priceBlock.appendChild(srOnly);
    priceBlock.appendChild(document.createTextNode(price));
  }
}

if (!window.customElements.get('purchase-options')) {
  window.customElements.define('purchase-options', PurchaseOptions);
}
